import React, { useContext, useEffect, useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import { CommonContext } from "../../context/CommonContext";
import { apisPath } from "../../utils/path";

const PremedicationSelect = ({
    name,
    value,
    onChange,
    onBlur,
    label = "Drug Type",
    required = false,
    error = false,
    helperText = "",
    disabled = false,
    fullWidth = true,
    size = "small",
    variant = "standard",
    InputLabelProps = {},
    SelectProps = {},
    ...otherProps
}) => {
    const { getMasterData, setIsLoading } = useContext(CommonContext);
    const [options, setOptions] = useState([]);

    // Fetch master data on mount
    useEffect(() => {
        const loadOptions = async () => {
            setIsLoading(true);
            try {
                const res = await getMasterData(apisPath?.masters?.preMedicationMaster, "premedication");
                if (res) {
                    setOptions(res);
                }
            } catch (error) {
                console.error("Error loading premedication master:", error);
            } finally {
                setIsLoading(false);
            }
        };
        loadOptions();
    }, []);

    const handleChange = (event) => {
        const selectedValue = event.target.value;
        if (onChange) {
            // Only pass the value as there is no drug_id anymore
            onChange(selectedValue);
        }
    };

    return (
        <TextField
            select
            name={name}
            label={label}
            value={value || ""}
            onChange={handleChange}
            onBlur={onBlur}
            required={required}
            error={error}
            helperText={helperText}
            disabled={disabled}
            fullWidth={fullWidth}
            size={size}
            variant={variant}
            InputLabelProps={{
                shrink: true,
                ...InputLabelProps
            }}
            SelectProps={{
                displayEmpty: true,
                ...SelectProps
            }}
            {...otherProps}
        >
            <MenuItem value="">
                <em>Select</em>
            </MenuItem>
            {options.map((option, idx) => (
                <MenuItem key={idx} value={option?.drug_type}>
                    {option?.drug_type}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default PremedicationSelect;